import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Category } from '../common/ContactAddress.type'
import { sortOptionItems, sortOptionsType } from '../data/sortOptionItems'
import {
  categoryFilter,
  favoriteFilter,
  groupFilter,
  searchWordFilter,
  selectCountFav,
  selectCurrContacts,
  sortContact,
} from '../slices/contactAddressSlice'
import { selectGroups } from '../slices/groupSlice'
import { selectRole } from '../slices/authSlice'
import { selectContactFilterType } from '../slices/contactAddressSlice'

const useFilterContact = () => {
  const currContactAddresses = useSelector(selectCurrContacts)
  const selectCountFavorite = useSelector(selectCountFav)
  const loggedinUserRole = useSelector(selectRole)
  const contactFilterType = useSelector(selectContactFilterType)

  const [searchWord, setSearchWord] = useState<string>('')
  const [selectedSort, setSelectedSort] =
    useState<sortOptionsType>('lastNameKana')
  const [isAsc, setIsAsc] = useState<boolean>(true)
  //console.log(`useFilterContact() contactFilterType="${contactFilterType}" loggedinUserRole="${loggedinUserRole}"`)
  const [filter, setFilter] = useState<Category>((contactFilterType === "" ? (loggedinUserRole !== 4 ? 'all' : 'personal') : contactFilterType as Category))   // 一般ユーザー: 4
  const [isFavorites, setIsFavorites] = useState<boolean>(false)

  const [selectedGroup, setSelectedGroup] = useState<number[]>([])

  const contactGroups = useSelector(selectGroups)

  const dispatch = useDispatch()

  const mergeArrays = (arrays: any) => {
    const merged = [].concat(...arrays)
    return Array.from(new Set(merged))
  }

  useEffect(() => {
    dispatch(searchWordFilter(searchWord))
    dispatch(categoryFilter(filter))
    dispatch(favoriteFilter(isFavorites))
    if (contactGroups.length && selectedGroup.length)
      dispatch(
        groupFilter(
          mergeArrays(
            contactGroups
              .filter((group) => selectedGroup?.includes(group.id))
              .map((group) => group.members.map((member) => member.id)),
          ),
        ),
      )
    dispatch(sortContact({ sortOption: selectedSort, orderAsc: isAsc }))
  }, [
    dispatch,
    searchWord,
    filter,
    isFavorites,
    selectCountFavorite,
    isAsc,
    selectedSort,
    contactGroups,
    selectedGroup,
  ])

  const sortOptions = Object.entries(sortOptionItems).map(([key, value]) => (
    <option key={key} value={key}>
      {value}
    </option>
  ))

  return {
    currContactAddresses,
    searchWord,
    setSearchWord,
    selectedSort,
    setSelectedSort,
    isAsc,
    setIsAsc,
    filter,
    setFilter,
    isFavorites,
    setIsFavorites,
    sortOptions,
    selectedGroup,
    setSelectedGroup,
  }
}

export default useFilterContact
